/**
 * @generated SignedSource<<dd382dc652282e793d7a7651d885fbbc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TaskSentiment = "NEGATIVE" | "NEUTRAL" | "POSITIVE";
import { FragmentRefs } from "relay-runtime";
export type RoutineOccasionFollowupResultCell_taskExecution$data = {
  readonly __typename: string;
  readonly checkValue?: TaskSentiment | null;
  readonly formattedNumberValue?: string | null;
  readonly isOptional: boolean;
  readonly textValue?: string | null;
  readonly " $fragmentType": "RoutineOccasionFollowupResultCell_taskExecution";
};
export type RoutineOccasionFollowupResultCell_taskExecution$key = {
  readonly " $data"?: RoutineOccasionFollowupResultCell_taskExecution$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoutineOccasionFollowupResultCell_taskExecution">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoutineOccasionFollowupResultCell_taskExecution",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isOptional",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "checkValue",
          "storageKey": null
        }
      ],
      "type": "TaskExecutionCheck",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formattedNumberValue",
          "storageKey": null
        }
      ],
      "type": "TaskExecutionNumber",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textValue",
          "storageKey": null
        }
      ],
      "type": "TaskExecutionText",
      "abstractKey": null
    }
  ],
  "type": "TaskExecution",
  "abstractKey": "__isTaskExecution"
};

(node as any).hash = "245b040403264a4e3fda76fd260c6832";

export default node;
